// Home page JS entry
import "../scss/home.scss";

document.addEventListener("DOMContentLoaded", () => {
	// Home page components init
});
